// DELEGATE — the HealthPathways status DERIVATION moved to `@heidi/evidence`;
// the integrations READ it derives from stayed, because that read is not
// evidence's.
//
// `/evidence/integrations` is an evidence-routed endpoint consumed by the
// integrations lane, and `useQueryEvidenceIntegrations` owns its cache identity.
// The census recorded this hook as unmovable for exactly that reason. What
// severs it is that the derivation needs the PAYLOAD, not the query: the list
// crosses as an explicit input and this file is the one place that knows where
// the list comes from, so the package names no foreign cache and the
// integrations lane keeps its hook.
//
// The exported signature is unchanged — no arguments, same four fields — so
// every call site and every `jest.mock('@/hooks/useHealthPathwaysStatus')`
// literal keeps resolving.
import { useQueryEvidenceIntegrations } from '@/hooks/query/integrations/evidence/useQueryEvidenceIntegrations';
import { useHealthPathwaysStatus as useHealthPathwaysStatusCore } from '@heidi/evidence/data';

/**
 * Single source of truth for HealthPathways status.
 *
 * Reads `requires_setup` and `setup_config` from the integrations endpoint.
 * No user-object dependency — the backend stores zone config on the integration entry.
 */
export function useHealthPathwaysStatus() {
  const { data: integrations } = useQueryEvidenceIntegrations();

  return useHealthPathwaysStatusCore(integrations);
}
